<template>
  <div id="app">
    <!-- 加载状态 -->
	<div v-if="!web3CheckCompleted" class="web3-loading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <p>正在检测Web3环境...</p>
      </div>
    </div>

    <!-- 只有在检测完成且不是Web3浏览器时显示错误提示 -->
	<div v-else-if="!isWeb3Browser" class="web3-error">
      <div class="error-container">
        <h2>{{ $t('navBottom.bottomOtherItem3') }}</h2>
        <p>{{ $t('ben-wang-zhan-ji-yu-yi-tai-fang-zhi-neng-he-yue-yun-hang-qing-shi-yong-trust-wallet-liu-lan-qi-fang-wen') }}</p>
        <div class="wallet-list">
          <p>MetaMask、Coinbase Wallet、Trust Wallet</p>
        </div>
      </div>
    </div>

    <!-- 只有在是Web3浏览器时显示内容 -->
    <div v-else class="app-content">
      <div v-show="showBoard == 1 || isPc">
        <NavPc v-if="isPc && !is3d"></NavPc>
        <router-view/>
        <NavBottomPc v-if="isPc && !is3d" v-show="isShowFooter"></NavBottomPc>
        <TabBar v-if="!isPc && !is3d" v-show="isShowFooter"/>
      </div>
      <div v-show="showBoard == 0 && !isPc">
        <Board/>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import TabBar from "@/components/TabBar.vue";
import NavPc from "@/components/nav_pc.vue";
import NavM from "@/components/nav_m.vue";
import NavBottomPc from "@/components/nav_bottom_pc.vue";
import {
  mapState
} from "vuex";
import store from "./store";
import Board from "./components/Board.vue";

export default {
  data() {
    return {
      windowWidth: document.body.clientWidth,
      // 不显示底部白名单
      isWeb3Browser: false,
      web3CheckCompleted: false,
     // 添加一个变量控制路由渲染
     routerReady: false
    };
  },
  components: {
    NavPc,
    NavM,
    NavBottomPc,
    TabBar,
    Board
  },

  beforeCreate() {
    // 在实例创建之前就阻止路由初始化
    if (typeof window !== 'undefined') {
      // 添加一个全局变量，用于控制路由初始化
      window.__WEB3_CHECK_COMPLETED__ = false;

      // 添加一个立即执行的样式，确保在Vue实例创建前就隐藏内容
      const style = document.createElement('style');
      style.id = 'web3-initial-style';
      style.innerHTML = `
        body > * {
          visibility: hidden !important;
        }
        .web3-loading, .web3-error {
          visibility: visible !important;
        }
        .app-content, [id="app"] > div:not(.web3-loading):not(.web3-error) {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  },

  created() {
 // 在created钩子中进行快速检测，避免页面闪烁
 this.checkWeb3Environment();
  },
  mounted() {
	 // 先初始化基础设置，确保样式正常
	 this.initializeBasicSettings();
    // 在mounted中进行一次完整的检测流程
    this.initializeApp();
  },
  watch: {
    // 监听页面宽度
    windowWidth(val) {
      console.log(val, "width");
      // store.commit('SetInnerWidth', val)
    },
  },
  computed: {
    ...mapState(["footerWhiteList", "isPc", "lginWhiteList", "showBoard"]),
    currentRouteName() {
      return this.$route.name;
    },
    is3d() {
      return this.lginWhiteList.indexOf(this.currentRouteName) > -1;
    },
    isShowFooter() {
      return this.footerWhiteList.indexOf(this.currentRouteName) == -1;
    },
  },
  methods: {

     // 检测Web3环境
     checkWeb3Environment() {
      // 检查是否存在window.ethereum对象或window.tronWeb对象
      if (typeof window.ethereum !== 'undefined' || typeof window.tronWeb !== 'undefined') {
        console.log("检测到ethereum对象或tronWeb对象，是Web3浏览器");
        this.isWeb3Browser = true;  // 设置为Web3浏览器
      } else {
        console.log("未检测到ethereum对象或tronWeb对象，非Web3浏览器");
        this.isWeb3Browser = false;  // 设置为非Web3浏览器
      }

      // 无论结果如何，都标记检测已完成
      this.web3CheckCompleted = true;
    },

 // 新增方法：初始化基础设置，确保样式正常
 initializeBasicSettings() {
      // 设置默认语言，确保错误提示能正确显示
      let lang = localStorage.getItem("lang") || this.$store.state.currentLanguage;
      this.$store.commit("SET_LANG", lang);
      this.$store.dispatch("listContents", lang == 'zh-tw' ? 'zh' : lang);

      // 设置响应式布局相关
      store.commit("SetInnerWidth", document.body.clientWidth);
      store.commit("SET_IS_PC", this.isMobileDevice());

      // 窗口大小变化监听
      window.onresize = () => {
        return (() => {
          this.windowWidth = document.documentElement.clientWidth;
          store.commit("SetInnerWidth", this.windowWidth);
          store.commit("SET_IS_PC", this.isMobileDevice());
        })();
      };

      // 设置字体大小
      this.setRootFontSize();
      window.addEventListener('DOMContentLoaded', this.setRootFontSize);
      window.addEventListener('resize', this.setRootFontSize);
    },


    // 初始化应用方法
    async initializeApp() {
      try {
        // 检测Web3环境
        this.checkWeb3Environment();

        if (this.isWeb3Browser) {
          // 如果是Web3浏览器，初始化应用内容
          this.initializeAppContent();

          // 启用路由
          setTimeout(() => {
            this.routerReady = true;
            window.__WEB3_CHECK_COMPLETED__ = true;
            const style = document.getElementById('web3-initial-style');
            if (style) {
              document.head.removeChild(style);
            }
          }, 100);
        } else {
          // 如果不是Web3浏览器，确保移除初始样式以显示错误提示
          console.log("非Web3浏览器，显示错误提示");
          this.web3CheckCompleted = true; // 确保检测已完成
          this.isWeb3Browser = false; // 确保标记为非Web3浏览器

          // 移除初始样式，让错误提示可见
          const style = document.getElementById('web3-initial-style');
          if (style) {
            document.head.removeChild(style);
          }
        }
      } catch (error) {
        console.error("初始化应用失败:", error);
        this.web3CheckCompleted = true;
        this.isWeb3Browser = false; // 确保在出错时也标记为非Web3浏览器
        const style = document.getElementById('web3-initial-style');
        if (style) {
          document.head.removeChild(style);
        }
      }
    },
    // 初始化应用内容的方法
    initializeAppContent() {
      // 添加可见性变化监听
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      // 设置是否虚拟账户
      let isVirtual = localStorage.getItem("virtualStatus") || 1;
      this.$store.commit("changeVirtual", isVirtual);

      // 初始化WebSocket
      try {
        this.$store.dispatch("GET_WS_MARKET").then((res) => {
          console.log(res, "ws");
        }).catch((err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }

      // 检查登录状态
      let isLogin = localStorage.getItem("isLogin");
      if (isLogin) {
        this.$store.dispatch("GET_USER_INFO").then((res) => {
          console.log(res, "user");
        });
      }
    },

    // 检测ETH地址
    async checkEthereumAddress() {
      try {
        // 仅判断是否存在window.ethereum对象
        if (typeof window.ethereum !== 'undefined') {
          console.log("检测到ethereum对象");

          // 请求用户授权并获取账户地址
          const accounts = await window.ethereum.request({
            method: 'eth_requestAccounts'
          }).catch(() => []);

          if (accounts && accounts.length > 0) {
            console.log("用户授权后获取到ETH地址:", accounts[0]);
            this.hasEthAddress = true;
            return true;
          } else {
            console.error("未获取到ETH地址或用户拒绝授权");
            this.hasEthAddress = false;
            return false;
          }
        } else {
          console.log("未检测到ethereum对象，非Web3浏览器");
          this.hasEthAddress = false;
          return false;
        }
      } catch (error) {
        console.error('ETH地址检测出错:', error);
        this.hasEthAddress = false;
        return false;
      }
    },


    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        try {
          this.$store.dispatch("GET_WS_MARKET").then((res) => {
            console.log(res, "ws");
          }).catch((err) => {
            console.log(err);
          });
        } catch (error) {
          console.log(error);
        }
      }
    },

    reconnectWebSocket() {
      // 检查 WebSocket 是否存在，如果不存在或者已经关闭则重新连接
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        // ws
        try {
          this.$store.dispatch("GET_WS_MARKET").then((res) => {
            console.log(res, "ws");
          }).catch((err) => {
            console.log(err);
          });
        } catch (error) {
          console.log(error);
        }
      }
    },

    isMobileDevice() {
      var userAgent = navigator.userAgent;
      return !(/Android|iPhone|iPad|iPod/i.test(userAgent));
    },

    setRootFontSize() {
      console.log(111);
      let baseWidth = 1920;
      if (window.innerWidth > 1000) {
        baseWidth = 1920;
      } else {
        baseWidth = 750;
      }
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let scale = 1;
      if (baseWidth == 750) {
        scale = (screenWidth / baseWidth) + .37;
      } else {
        // scale=(screenWidth/baseWidth) + .2;
        scale = (screenWidth / baseWidth) + 1;
      }
      console.log(scale, 'scale');
      const maxRemSize = 100;
      const rootFontSize = Math.min(maxRemSize, 100 * scale);
      console.log(rootFontSize, 'rootFontSize');
      document.documentElement.style.fontSize = rootFontSize + 'px';
    }
  },
};
</script>
<style>
@import "reset.css";

/* @media screen and (min-width: 1000px) {
#app {
  width: 1440px;
  margin: 0 auto;
}
} */
body {
  font-size: 0.16rem;
  background-color: #1E152A;
}

img,
video {
  max-width: 100%;
  height: auto;
}

.button {
  cursor: pointer;
  padding: 0 .36rem;
  height: 100%;
  border-radius: .2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: .2rem;
  color: #000;
  -webkit-tap-highlight-color: transparent
}

.button .icon {
  margin-right: .12rem;
  width: .24rem;
  height: .24rem
}

#app {
  margin: 0 auto;
  width: 100%;
  max-width: 14.4rem;
  font-family: Mabry Pro;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  font-size: .16rem;
}

.input_fields .el-input .el-input__wrapper {
  box-shadow: none;
  background: none;
}

.button.round {
  border-radius: .32rem
}

.button.normal {
  background: #e8e8e8
}

.button.yellow {
  background: linear-gradient(180deg, #ffdc61, #ffbc49)
}

.button.black {
  background: #402430;
  color: #fff
}

.button.line {
  background: #fff;
  border: .02rem solid #000;
  box-sizing: border-box
}

.button.disabled {
  background: #dfdfdf;
  color: #8a8a8a
}

.el-scrollbar__bar {
  opacity: 1 !important;
}

/* Web3加载样式 */
.web3-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 80px;
  height: 80px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Web3错误提示样式 */
.web3-error {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.error-container {
  background-color: white;
  padding: 30px;
  border-radius: 16px;
  text-align: center;
  max-width: 90%;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.error-container h2 {
  color: #ff3b30;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}

.error-container p {
  margin: 16px 0;
  font-size: 18px;
  line-height: 1.5;
  color: #333;
}

.wallet-list {
  margin-top: 24px;
  padding: 16px;
  background-color: #f8f8f8;
  border-radius: 10px;
}

.wallet-list p {
  margin: 10px 0;
  font-size: 18px;
}

.app-content {
  transition: none !important;
}


/* 添加响应式样式，适配移动设备 */
@media screen and (max-width: 768px) {
  .loading-spinner {
    width: 60px;
    height: 60px;
    border-width: 6px;
  }

  .error-container {
    padding: 24px;
  }

  .error-container h2 {
    font-size: 22px;
  }

  .error-container p {
    font-size: 18px;
  }

  .wallet-list p {
    font-size: 18px;
  }
}

/* 特别小的屏幕 */
@media screen and (max-width: 375px) {
  .loading-spinner {
    width: 50px;
    height: 50px;
    border-width: 5px;
  }

  .error-container {
    padding: 20px;
  }

  .error-container h2 {
    font-size: 20px;
  }

  .error-container p {
    font-size: 16px;
  }

  .wallet-list p {
    font-size: 16px;
  }
}
.loading-content p {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
</style>
